// extracted by mini-css-extract-plugin
module.exports = {"carousel":"slider_carousel__1CeDk","control-dots":"slider_control-dots__3wqzP","sliderImage":"slider_sliderImage__1R6Ry"};